import styled from "styled-components";

export const RaceBarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  canvas {
    position: relative;
  }
`;
